import { batch } from 'react-redux';
import clearDirectorRequest from '../Broadcast/clearDirectorRequest';
import muteAudio from '../Broadcast/muteAudio';
import setDirectorControls from '../Broadcast/setDirectorControls';
import setDirectorRequestMessage from '../Broadcast/setDirectorRequestMessage';
import unmuteAudio from '../Broadcast/unmuteAudio';
import { MUTE } from 'constants/DirectorControls';

/** Action creator to handle mute status */
function handleMuteStatus(isMuted) {
  return (dispatch, getState) => {
    const {
      meeting: { meetingSession }
    } = getState();
    const muteAction = isMuted ? muteAudio(true, true) : unmuteAudio(true);

    if (!isMuted) {
      meetingSession.audioVideo.realtimeSetCanUnmuteLocalAudio(true);
    }

    batch(() => {
      dispatch(muteAction);
      dispatch(
        setDirectorControls({
          key: MUTE,
          value: !isMuted
        })
      );

      dispatch(clearDirectorRequest({ requestType: MUTE }));
      dispatch(
        setDirectorRequestMessage({
          key: MUTE,
          value: null
        })
      );
    });
  };
}

export default handleMuteStatus;
